import { render, staticRenderFns } from "./Membro.vue?vue&type=template&id=7a84e861&scoped=true&"
import script from "./Membro.vue?vue&type=script&lang=js&"
export * from "./Membro.vue?vue&type=script&lang=js&"
import style0 from "./Membro.vue?vue&type=style&index=0&id=7a84e861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84e861",
  null
  
)

export default component.exports